// extracted by mini-css-extract-plugin
export default {"subtitle":"Eg2O6Pti","list":"GS0L13EA","listItem":"VzCcS5uv"};